import { LdtAppRepository } from '@ldt/api/app_repository';
import { AuthenticationService } from 'src/api/authentication_service';
import {
  OrganizationFieldsFragment,
  OrganizationListFieldsFragment,
  OrganizationWorkflowType,
} from 'src/types';

const arteraOrganization: OrganizationFieldsFragment = {
  id: '1',
  name: 'artera',
  displayName: 'Artera',
  workflowType: OrganizationWorkflowType.Clinic,
  features: {
    isInternational: false,
    allowTStageNotProvided: false,
  },
};

const pathnetOrganization: OrganizationFieldsFragment = {
  id: '2',
  name: 'pathnet',
  displayName: 'PathNet',
  workflowType: OrganizationWorkflowType.AncillaryLab,
  features: {
    isInternational: false,
    allowTStageNotProvided: false,
  },
};

const ddxOrganization: OrganizationFieldsFragment = {
  id: '3',
  name: 'ddx-foundation',
  displayName: 'DDx Foundation',
  workflowType: OrganizationWorkflowType.AncillaryLab,
  features: {
    isInternational: false,
    allowTStageNotProvided: false,
  },
};

const tempusOrganization: OrganizationFieldsFragment = {
  id: '4',
  name: 'tempus',
  displayName: 'Tempus',
  workflowType: OrganizationWorkflowType.Tempus,
  features: {
    isInternational: false,
    allowTStageNotProvided: false,
  },
};

const northwesternOrganization: OrganizationFieldsFragment = {
  id: '4',
  name: 'northwestern',
  displayName: 'Northwestern',
  workflowType: OrganizationWorkflowType.Clinic,
  features: {
    isInternational: false,
    allowTStageNotProvided: false,
  },
};

const coreplusLabOrganization: OrganizationFieldsFragment = {
  id: '5',
  name: 'coreplus-lab',
  displayName: 'CorePlus Lab',
  workflowType: OrganizationWorkflowType.DirectUploadLab,
  features: {
    isInternational: false,
    allowTStageNotProvided: true,
  },
};

const organizations: OrganizationFieldsFragment[] = [
  arteraOrganization,
  pathnetOrganization,
  ddxOrganization,
  tempusOrganization,
  northwesternOrganization,
  coreplusLabOrganization,
];

/**
 * Implementation of the App Repository for the Ldt platform on a fake backend.
 */
export class LdtFakeAppRepository implements LdtAppRepository {
  getOrganizations(): Promise<OrganizationListFieldsFragment[]> {
    return Promise.resolve(organizations);
  }

  getEffectiveOrganization(): Promise<OrganizationFieldsFragment> {
    const selectedName =
      AuthenticationService.getInstance().getOrganizationHeader();
    if (selectedName) {
      const match = organizations.find((org) => org.name === selectedName);
      if (match) {
        return Promise.resolve(match);
      }
    }

    return Promise.resolve(arteraOrganization);
  }
}
